// extracted by mini-css-extract-plugin
export var bigButton = "cookie-module--bigButton--9d7d7";
export var block = "cookie-module--block--3419f";
export var borderlessButton = "cookie-module--borderlessButton--fd9cd";
export var button = "cookie-module--button--71506";
export var buttonWrapper = "cookie-module--buttonWrapper--96b6f";
export var close = "cookie-module--close--7e4eb";
export var closeImg = "cookie-module--closeImg--d1bda";
export var img = "cookie-module--img--74d5a";
export var link = "cookie-module--link--9cc03";
export var popupHeading = "cookie-module--popupHeading--9bd7a";
export var popupWrapper = "cookie-module--popupWrapper--1aba1";
export var rejectButton = "cookie-module--rejectButton--90478";
export var rightAlignment = "cookie-module--rightAlignment--5c306";
export var text = "cookie-module--text--59c95";
export var textWrapper = "cookie-module--textWrapper--579bf";
export var wrapper = "cookie-module--wrapper--9fe19";